import { Component, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { SuccessDialogComponent } from 'src/app/modules/dialogs/success_dialog/success_dialog.component';
import { SellersService } from 'src/app/service/seller/sellers.service';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'navbar_one_demo',
  templateUrl: './navbar_one_demo.component.html',
  styleUrls: ['./navbar_one_demo.component.scss']
})
export class NavbarOneDemoComponent implements OnInit {
  isCollapsed = false;
  isFirstMenuVisible = true;
  isSecondMenuVisible = false;

  flag_client_selected:boolean = false;
  clientSelected;

  flag_open: boolean = false;

  constructor(
    private router: Router,
    private _authService: AuthService,
    private change: ChangeDetectorRef,
    private _sellerService: SellersService, 
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (!localStorage.getItem('sidebarCollapsed')) {
      this.isCollapsed = false;
    } else {
      this.isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';
    }

    this.onResize(window);
  }

  updateMatMenuBackground() {
    const isDarkMode = document.documentElement.classList.contains('dark');
    const menuPanel = document.querySelector('.mat-menu-panel') as HTMLElement;

    if (menuPanel) {
      if (isDarkMode) {
        menuPanel.style.setProperty('background', '#0E151D');
      } else {
        menuPanel.style.setProperty('background', '#FFFFFF');
      }
    }
  }

  clear_select() {
    localStorage.removeItem('seller');

    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      autoFocus: false,
      panelClass: 'no-padding-dialog',
      data: {
        title: 'Selección eliminada',
        content: 'Selección eliminada correctamente.',
        buttons: [{ label: 'Aceptar', action: 'ok' }]
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this._sellerService.change_flag_select_client(false);
      this.clientSelected = false;
      this.ngOnChanges();
    });
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth <= 1100) {
      this.isFirstMenuVisible = false;
      this.isSecondMenuVisible = true;

      this.isCollapsed = false;
      localStorage.setItem('sidebarCollapsed', this.isCollapsed.toString());
      window.dispatchEvent(new Event('storage'));

    } else {
      this.isFirstMenuVisible = true;
      this.isSecondMenuVisible = false;
    }
  }

  isActive(route: string): boolean {
    return this.router.url === route;
  }

  navigate(route: string): void {
    if (!this.isActive(route)) {
      this.router.navigate([route]);
    }
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    localStorage.setItem('sidebarCollapsed', this.isCollapsed.toString());
    window.dispatchEvent(new Event('storage'));
  }

  ngOnChanges(){
    this.change.detectChanges();
    this.ngOnInit();
  }

  showOffcanvas() {
    this.flag_open = true;
    const offcanvas = new bootstrap.Offcanvas(document.getElementById('offcanvasNavbar'));
    offcanvas.show();
  }

  onOffcanvasClose() {
    this.flag_open = false;
  }

  logout() {
    // Limpiar cookies
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    
    // Limpiar almacenamiento local
    localStorage.clear()
    this._sellerService.change_flag_select_client(false);
    // Limpiar almacenamiento de sesión
    sessionStorage.clear()

    this._authService.signOut()

    // Redirigir a la página de inicio de sesión
    this.router.navigate(['/solfium-one-demo'])
  }
}